import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import { DriverOrder } from "@/interface/dispatch/driver_order";
import { orderSlipQueryKey } from "../dp_ordeer_slip/useOrderSlip";

export const driverOrderQueryKey = "driverOrder";

/**
 * 운송 상세 조회 (driver_order)
 */
export const useDriverOrderDetail = (orderSlipCode: string, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [driverOrderQueryKey, "detail", orderSlipCode],
    queryFn: async () => {
      const res = await api.get(`/driver-order/detail/${orderSlipCode}`);
      return res.data || res;
    },
    enabled: options?.enabled !== false && !!orderSlipCode,
  });
};

/**
 * 기사 주문 추가 또는 수정
 * driver_order 테이블에 INSERT
 */
export const useInsertAndUpdateDriverOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (driverOrder: DriverOrder) => {
      return api.post("/driver-order", driverOrder);
    },
    onSuccess: () => {
      // 성공 시 orderSlip 쿼리 무효화하여 리스트 새로고침
      queryClient.invalidateQueries({ queryKey: [orderSlipQueryKey] });
    },
  });
};

/**
 * 기사 주문 삭제 (배차취소)
 * driver_order 테이블에서 DELETE
 */
export const useDeleteDriverOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (orderSlipCode: string) => {
      return api.delete(`/driver-order/${orderSlipCode}`);
    },
    onSuccess: () => {
      // 성공 시 orderSlip 쿼리 무효화하여 리스트 새로고침
      queryClient.invalidateQueries({ queryKey: [orderSlipQueryKey] });
    },
  });
};
